module.exports = __webpack_public_path__ + "media/LandingPageAssets/GroupWaitlist1-289a8be6.svg";